import {Button, Form, InputGroup} from "react-bootstrap";
import React, {useRef} from "react";
import {ErrorMessage, Field} from "formik";

export function SetTime({feedback, time, setTime, invalid, setInvalid, disabled, required = false}) {
    const ref = useRef();
    return <InputGroup hasValidation>
        <Button variant="outline-secondary" disabled={disabled} onClick={() => {
            setInvalid(false)
            setTime("")
        }}><i className="bi bi-x-lg"/>
        </Button>
        <Form.Control type="time" isInvalid={invalid} value={time} disabled={disabled} onChange={e => { //repeatType === 0 ? "" :
            setInvalid(false)
            setTime(e.target.value)
        }} required={required} ref={ref} onClick={() => ref.current?.showPicker()}
        />
        <Form.Control.Feedback type="invalid">{feedback}</Form.Control.Feedback>
    </InputGroup>
}

export function SetTimeField({name}) {
    const ref = useRef();
    return (
        <Field name={name}>
            {({field, form, meta}) => (
                <div className="w-100">
                    <InputGroup >
                        <Form.Control
                            type="time"
                            value={field.value || ""}
                            onChange={e => form.setFieldValue(name, e.target.value)}
                            ref={ref}
                            onClick={() => ref.current?.showPicker()}
                        />

                        <Button
                            variant="outline-secondary"
                            onClick={() => form.setFieldValue(name, "")}
                        >
                            <i className="bi bi-x-lg"/>
                        </Button>
                    </InputGroup>
                    {meta.touched && meta.error && (<div className="text-danger">{meta.error}</div>)}
                </div>
            )
            }
        </Field>
    )
}
